var DialogApprovalsEquipmentsRejectModule = /** @class */ (function () {
    function DialogApprovalsEquipmentsRejectModule() {
    }
    return DialogApprovalsEquipmentsRejectModule;
}());
export { DialogApprovalsEquipmentsRejectModule };
